<template>
  <div class="pb-4 mt-4 card">
    <div class="px-4 sm:px-6 lg:px-8">
      <div class="flow-root">
        <div class="flex justify-end items-center mt-2">
          <button
            v-if="canMergeChalans"
            class="px-4 py-2 text-white bg-green-500 rounded disabled:opacity-50"
            @click="redirectSelected"
          >
            Merge Chalans To Sale
          </button>
        </div>
        <div class="card-header">
          <span
            class="mb-0 text-lg font-bold"
            style="text-transform: capitalize"
          >
            Customer Chalans
          </span>
        </div>
        <div class="overflow-x-auto -mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block py-2 min-w-full align-middle sm:px-6 lg:px-8"
          >
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
                <tr class="bg-gray-50">
                  <th class="px-4 py-3.5">
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @change="toggleSelectAll"
                    />
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    <div class="mb-2">Date</div>
                    <input
                      v-model="filters.fromDate"
                      type="date"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      placeholder="From Date"
                      @change="debounceFilter"
                    />
                    <input
                      v-model="filters.toDate"
                      type="date"
                      class="px-2 py-1 mt-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      placeholder="To Date"
                      @change="debounceFilter"
                    />
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    <div class="mb-2">Branch</div>
                    <select
                      v-model="filters.branch"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      @change="debounceFilter"
                    >
                      <option value="">All Branches</option>
                      <option value="Baner">Baner</option>
                      <option value="Pune">Pune</option>
                    </select>
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    <div class="mb-2">Customer</div>
                    <input
                      v-model="filters.customerName"
                      type="text"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      placeholder="Search customer..."
                      @input="debounceFilter"
                    />
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    <div class="mb-2">Number</div>
                    <input
                      v-model="filters.chalanNumber"
                      type="text"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      placeholder="Search chalan number..."
                      @input="debounceFilter"
                    />
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    <div class="mb-2">Total</div>
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    <div class="mb-2">Type</div>
                    <select
                      v-model="filters.type"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      @change="debounceFilter"
                    >
                      <option value="">All Types</option>
                      <option value="Inward">Inward</option>
                      <option value="Outward">Outward</option>
                    </select>
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-sm font-semibold text-left text-gray-900"
                  >
                    <div class="mb-2">Status</div>
                    <select
                      v-model="filters.status"
                      class="px-2 py-1 w-full text-xs rounded border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                      @change="debounceFilter"
                    >
                      <option value="">All Statuses</option>
                      <option value="Pending">Pending</option>
                      <option value="Dispatched">Dispatched</option>
                      <option value="Completed">Completed</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-sm font-semibold text-left text-gray-900"
                  >
                    <div class="mb-2">Actions</div>
                    <button
                      @click="clearFilters"
                      class="px-2 py-1 w-full text-xs text-white bg-gray-500 rounded hover:bg-gray-600 focus:outline-none focus:ring-1 focus:ring-gray-500"
                    >
                      Clear All
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <template v-if="loading">
                  <tr class="text-center">
                    <td colspan="8" class="px-6 py-4">
                      <div class="flex justify-center items-center">
                        <div
                          class="w-8 h-8 rounded-full border-b-2 border-blue-600 animate-spin"
                        ></div>
                        <span class="ml-2">Loading...</span>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else-if="customerChalans.length === 0">
                  <tr class="text-center">
                    <td colspan="8" class="px-6 py-4 text-gray-500">
                      No customer chalans found
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="item in customerChalans" :key="item.id">
                    <!-- Checkbox per row -->
                    <td class="px-4">
                      <input
                        type="checkbox"
                        :value="item.id"
                        v-model="selectedItems"
                      />
                    </td>
                    <td
                      class="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0"
                    >
                      {{ item.date | convertDate }}
                    </td>
                    <td
                      class="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0"
                    >
                      <span
                        v-if="item.branch === 'Baner'"
                        class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-700 bg-red-50 rounded-full ring-1 ring-inset ring-red-400"
                        >{{ item.branch }}</span
                      >
                      <span
                        v-else
                        class="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-50 rounded-full ring-1 ring-inset ring-blue-700/10"
                        >{{ item.branch }}</span
                      >
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.user }}
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.chalan_number }}
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.total }}
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      <span
                        :class="{
                          'bg-red-500': item.type === 'Inward',
                          'bg-green-500': item.type === 'Outward'
                        }"
                        class="px-2 py-1 text-xs font-medium text-white rounded-full"
                      >
                        {{ item.type }}
                      </span>
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      <span
                        :class="{
                          'bg-red-500':
                            item.status === 'Cancelled' ||
                            item.status === 'Pending',
                          'bg-yellow-500': item.status === 'Dispatched',
                          'bg-green-500':
                            item.status === 'Completed' ||
                            item.status === 'Delivered'
                        }"
                        class="px-2 py-1 text-xs font-medium text-white rounded-full"
                      >
                        {{ item.status }}
                      </span>
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      <div class="inline-block relative text-left">
                        <div>
                          <button
                            type="button"
                            class="inline-flex gap-x-1.5 justify-center px-3 py-2 w-full text-sm font-semibold text-gray-900 bg-blue-300 rounded-md ring-1 ring-inset ring-gray-300 shadow-sm hover:bg-blue-200"
                            id="menu-button"
                            aria-expanded="true"
                            aria-haspopup="true"
                            @click="handleDropdown(item)"
                          >
                            Actions
                          </button>
                        </div>
                        <div
                          v-if="item.isDropdownOpen === true"
                          class="absolute right-0 z-10 mt-2 w-56 bg-white rounded-md ring-1 shadow-lg origin-top-right ring-black/5 focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabindex="-1"
                        >
                          <div class="py-1" role="none">
                            <!-- Active: "bg-gray-100 text-gray-900 outline-none", Not Active: "text-gray-700" -->
                            <span
                              @click="handleEdit(item)"
                              class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
                              role="menuitem"
                              tabindex="-1"
                              id="menu-item-0"
                              >Edit</span
                            >
                            <span
                              @click="handlePrint(item)"
                              class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
                              role="menuitem"
                              tabindex="-1"
                              id="menu-item-1"
                              >Print</span
                            >
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="flex justify-between items-center px-4 mt-4">
            <!-- Records Per Page Selector -->
            <div class="flex items-center space-x-2">
              <label for="per-page" class="text-sm font-medium"
                >Records per page:</label
              >
              <select
                id="per-page"
                v-model="perPage"
                @change="getcustomerChalans()"
                class="px-2 py-1 rounded border"
              >
                <option
                  v-for="option in perPageOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
            </div>

            <Pagination
              :currentPage="pagination.current_page"
              :totalPages="pagination.last_page"
              @page-change="handlePageChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import Pagination from "../../components/Pagination.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { print } from "@/utils/print";

export default {
  data() {
    return {
      customerChalans: [],
      pagination: {
        current_page: 1,
        prev_page_url: null,
        next_page_url: null,
        last_page: 1
      },
      perPage: 20,
      perPageOptions: [5, 10, 25, 50],
      paginationLinks: [],
      selectedItems: [], // selected chalan IDs
      selectAll: false,
      filters: {
        customerName: "",
        status: "",
        fromDate: "",
        toDate: "",
        branch: "",
        type: "",
        chalanNumber: ""
      },
      debounceTimer: null,
      loading: false
    };
  },
  computed: {
    canMergeChalans() {
      if (this.selectedItems.length === 0) {
        return false;
      }

      const selectedChalans = this.customerChalans.filter(chalan =>
        this.selectedItems.includes(chalan.id)
      );

      // Check if all selected chalans have status "dispatched"
      const allDispatched = selectedChalans.every(
        chalan => chalan.status.toLowerCase() === "dispatched"
      );

      if (!allDispatched) {
        return false;
      }

      // Check if all selected chalans have the same customer
      const customers = [
        ...new Set(selectedChalans.map(chalan => chalan.userId))
      ];
      const sameCustomer = customers.length === 1;

      return sameCustomer;
    },
    hasActiveFilters() {
      return Object.values(this.filters).some(
        value => value !== "" && value !== null
      );
    }
  },
  filters: {
    convertDate(date) {
      return format(date, "DD MMM YYYY");
    }
  },
  components: {
    Pagination
  },
  mounted() {
    this.getCustomerChalans();
  },

  methods: {
    handlePageChange(page) {
      const filterParams = this.buildFilterParams();
      this.getCustomerChalans(
        `/api/v1/customer-chalans?page=${page}&per_page=${this.perPage}${filterParams}`
      );
    },
    buildFilterParams() {
      const params = [];
      if (this.filters.fromDate) {
        params.push(`from_date=${this.filters.fromDate}`);
      }
      if (this.filters.toDate) {
        params.push(`to_date=${this.filters.toDate}`);
      }
      if (this.filters.branch) {
        params.push(`branch=${encodeURIComponent(this.filters.branch)}`);
      }
      if (this.filters.customerName) {
        params.push(
          `customer_name=${encodeURIComponent(this.filters.customerName)}`
        );
      }
      if (this.filters.chalanNumber) {
        params.push(
          `chalan_number=${encodeURIComponent(this.filters.chalanNumber)}`
        );
      }
      if (this.filters.type) {
        params.push(`type=${encodeURIComponent(this.filters.type)}`);
      }
      if (this.filters.status) {
        params.push(`status=${encodeURIComponent(this.filters.status)}`);
      }
      return params.length > 0 ? `&${params.join("&")}` : "";
    },
    getCustomerChalans(
      url = `/api/v1/customer-chalans?page=1&per_page=${this.perPage}`
    ) {
      this.loading = true;
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}${url}`)
        .then(response => {
          this.customerChalans = response.data.data.map(i => {
            return {
              ...i,
              isDropdownOpen: false
            };
          });
          this.pagination = {
            current_page: response.data.meta.current_page,
            prev_page_url: response.data.meta.prev_page_url,
            next_page_url: response.data.meta.next_page_url,
            last_page: response.data.meta.last_page
          };
          this.generatePaginationLinks();
          this.loading = false;
        })
        .catch(error => {
          console.error("Error fetching customer chalans:", error);
          this.$notify({
            message: "Error fetching customer chalans",
            type: "danger",
            title: "Error"
          });
          this.loading = false;
        });
    },
    generatePaginationLinks() {
      const links = [];
      const filterParams = this.buildFilterParams();
      for (let i = 1; i <= this.pagination.last_page; i++) {
        links.push({
          number: i,
          url: `/api/v1/customer-chalans?page=${i}&per_page=${this.perPage}${filterParams}`,
          active: i === this.pagination.current_page
        });
      }
      this.paginationLinks = links;
    },
    handleDropdown(item) {
      const data = this.customerChalans.map(i => {
        if (i.id === item.id) {
          return {
            ...i,
            isDropdownOpen: item.isDropdownOpen === true ? false : true
          };
        } else {
          return {
            ...i,
            isDropdownOpen: false
          };
        }
      });
      this.customerChalans = data;
    },
    handleEdit(item) {
      this.$router.push(`/customer-chalans/${item.id}/`);
    },
    async handlePrint(item) {
      try {
        // Close the dropdown
        this.handleDropdown(item);

        // Fetch the complete chalan data
        const response = await apiHelper.call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/customer-chalans/${item.id}`
        );

        const chalanData = response.data;

        // Prepare the data for printing in the same format as Pos.vue
        const printData = {
          products: chalanData.products || [],
          user: chalanData.user || {},
          chalanNumber: chalanData.chalan_number || chalanData.id,
          is_inward: chalanData.is_inward || false,
          type:
            chalanData.type || (chalanData.is_inward ? "Inward" : "Outward"),
          status: chalanData.status || "Unknown",
          branch: chalanData.branch || "Unknown",
          subTotal: chalanData.sub_total || 0,
          grandTotal: chalanData.grand_total || 0,
          roundedOff: chalanData.rounded_off || 0,
          createdAt: chalanData.created_at || chalanData.date,
          updatedAt: chalanData.updated_at || chalanData.date
        };

        // Print the chalan using the same print utility as Pos.vue
        print(printData, "customer-chalan");

        this.$notify({
          message: "Chalan sent to printer!",
          type: "success",
          title: "Success"
        });
      } catch (error) {
        console.error("Error printing chalan:", error);
        this.$notify({
          message: "Error printing chalan. Please try again.",
          type: "danger",
          title: "Error"
        });
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedItems = this.customerChalans.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    redirectSelected() {
      const selectedCustomerChalans = this.customerChalans
        .filter(chalan => this.selectedItems.includes(chalan.id))
        .map(chalan => ({
          id: chalan.id,
          userId: chalan.userId,
          status: chalan.status
        }));
      window.sessionStorage.removeItem("customerChalansToMerge");
      window.sessionStorage.setItem(
        "customerChalansToMerge",
        JSON.stringify(selectedCustomerChalans)
      );
      this.$router.push({
        name: "merge-customer-chalans"
      });
    },
    debounceFilter() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        const filterParams = this.buildFilterParams();
        this.getCustomerChalans(
          `/api/v1/customer-chalans?page=1&per_page=${this.perPage}${filterParams}`
        );
      }, 500); // 500ms debounce time
    },
    clearFilters() {
      this.filters = {
        customerName: "",
        status: "",
        fromDate: "",
        toDate: "",
        branch: "",
        type: "",
        chalanNumber: ""
      };
      this.debounceFilter();
    }
  }
};
</script>
